module.exports = __webpack_public_path__ + "static/media/corporate-services-img58.e53ef7be.jpg";